import React from "react";
import CalImg from "../../../ebusHomePics/calender.png";
import ClockImg from "../../../ebusHomePics/clock.png";
import * as Scroll from "react-scroll";

const OTBus = (props) => {
  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <div className="row">
      <div className="w-100 p-0" id="jobHd">
        <div className="container w-100 h-100 d-flex align-items-center">
          <h1 className="text-white">
            <b>حرکت به موقع اتوبوس</b>
          </h1>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-3"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>حرکت به موقع اتوبوس</b>
          </h2>
          <div className="d-block d-md-flex flex-wrap my-5">
            <div className="col-12 col-md-6">
              <h3 style={{ textAlign: "justify", lineHeight: "30px" }}>
                یکی از رایج ترین نارضایتی‌ها در سفر بین شهری با اتوبوس تاخیر در
                زمان حرکت و زمان رسیدن به مقصد می‌باشد. قطعا برای شما به عنوان
                یک شهروند تو حوزه های مختلفی که فعالیت دارید اعم از دانشجویان،
                اساتید,کارمندان و ... پیش آمده که بخواهید طبق زمان مشخصی از
                شهری به شهر دیگر سفر کنید و راس یک ساعتی به یک قرارکاری,جلسه
                مهم,دانشگاه و کلاستون برسید و دیرتر از اون‌چه که برنامه‌ریزی
                کرده بودید به مقصد مورد نظرتان برسید. بسیاری از مردم با برنامه
                ریزی قبل از سفر,سعی بر مدیریت و استفاده بهینه از زمان خود
                دارند. در واقع کنترل زمان در گرو برنامه ریزی صحیح است . نمی‌توان
                اهمیت بسیار بالای مدیریت و برنامه ریزی را انکار کرد,چرا که
                تاثیر مستقیمی بر کیفیت زندگی همه افراد جامعه دارد,برنامه ریزی،
                فرآیند سازماندهی برنامه‌های سفر می‌باشد.
              </h3>
            </div>
            <div
              className="col-12 col-md-6 d-flex justify-content-center"
              style={{ height: "30rem" }}
            >
              <img
                src={CalImg}
                className="w-75 h-75"
                style={{ objectFit: "contain" }}
              />
            </div>
            <div
              className="col-12 col-md-6 d-flex justify-content-center"
              style={{ height: "30rem" }}
            >
              <img
                src={ClockImg}
                className="w-75 h-75"
                style={{ objectFit: "contain" }}
              />
            </div>
            <div className="col-12 col-md-6">
              <h3 style={{ lineHeight: "30px", textAlign: "justify" }}>
                ایباس با برنامه‌ریزی دقیق سفر شرایطی را برای شما فراهم می آورد
                که با کم ترین میزان تاخیر,سفر کنید و تجربه سفری متفاوت را در
                بهترین بازه های زمانی و تاریخی را با ما داشته باشید. اهمیت تعیین
                بهترین زمان سفر اتوبوسی از 2 جنبه در ایباس قابل بررسی می‌باشد :
                1. هزینه سفر ,که ایباس سعی دارد با بهینه کردن هزینه ها ,پایین
                ترین قیمت بلیط اتوبوسی را با اطمنیان در اختیار شما بگذارد. 2. در
                نظر گرفتن شلوغی و ازدحام یکی از موارد مهم برای تعیین بهترین زمان
                سفر می‌باشد,به خصوص در زمان های پیک سال,با در نظر گرفتن زمان
                ترافیک در مسیر ,شرایط آب و هوایی و اقلیم منطقه و ... موارد
                دیگر. طبق زمان بندی خودتون وپیشنهادات بهترین زمان سفر ایباس بلیط
                اتوبوس‌تون رو از طریق سایت و اپلیکیشن ایباس با چندتا کلیک به
                راحتی تهیه کنید. #فصل_جدید_سفر
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTBus;
